<template>
  <div class="wrapper">
      <v-expand-transition>
        <router-view />
      </v-expand-transition>
  </div>
</template>
<script>
export default {
  name: "Operation",
  data() {
    return {
     
    };
  },
  beforeRouteLeave (to, from, next) {
      this.$store.dispatch('base/SET_SUB_MENU', []);
      this.$store.dispatch('base/SET_HEADER_ACTIONS', {});
      next();
  },
  methods: {
  },
  computed: {
    
  },
  mounted() {
  },
};
</script>
